"use client";

import { ActivityDisplayPreview } from "./previews";

type ClimbingDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function ClimbingDisplay({ data, participants }: ClimbingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="climbing"
      data={data}
      participants={participants}
    />
  );
}
